/** Visible deploy marker (bottom-right). */
export default function BuildBadge() {
  const buildId = process.env.REACT_APP_BUILD_ID || "auth-fix-v3";
  return (
    <div
      style={{
        position: "fixed",
        right: 8,
        bottom: 8,
        zIndex: 9999,
        fontSize: 11,
        opacity: 0.65,
        padding: "2px 6px",
        background: "#212529",
        color: "#fff",
        borderRadius: 4,
        pointerEvents: "none",
        fontFamily: "monospace",
      }}
      aria-hidden
    >
      build:{buildId}
    </div>
  );
}
